// import React from "react";
import * as api from "../../api/index";
import "./Signup.css";
import { useDispatch, useSelector } from "react-redux";
import { signUp, clearErrors } from "../../actions/userActions";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import AddPhoneNumber from "../../Components/AddPhoneNumber";
import { useMutation } from "react-query";

function Signup({ history }) {
  const dispatch = useDispatch();
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [contactNo, setContactNo] = useState();
  const { mutate } = useMutation(api.postSignUp);

  // const { loading, error, registered } = useSelector((state) => state.auth);

  // useEffect(() => {
  // if (registered) {
  //   history.push("/sign-in");
  // }

  //   if (error) {
  //     Swal.fire({
  //       position: "top-end",
  //       icon: "error",
  //       title: error,
  //       showConfirmButton: true,
  //       timer: 2000,
  //     });
  //     dispatch(clearErrors());
  //   }
  // }, [dispatch, history, error, registered]);

  const validation = () => {
    let errors = {};
    if (data.password !== data.confirmPassword) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Oops! The passwords you entered do not match",
        timer: 2000,
        showConfirmButton: false,

        showConfirmButton: true,
      });
      errors.confirmPassword = "Passwords do not match";
    }
    return Object.keys(errors).length;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const valid = validation();
    if (valid > 0) return;
    // dispatch(signUp(data));
    setIsLoading(true);
    let res;
    mutate(data, {
      onSuccess: (data) => {
        console.log("userdata", res);
        setIsLoading(false);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: `Sign-up successful!`,
          text: " Please check your email and verify your account",
          showConfirmButton: false,

          timer: 2000,
        });
        history.push("/sign-in");
      },
      onError: (err) => {
        console.log(err.response?.data?.message);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `${"Oops! Sign-up failed."}`,
          text: err.response?.data?.message,
          timer: 2000,
          showConfirmButton: false,
        });
      },
    });

    // try {
    //   res = await api.postSignUp(data);
    //   console.log("userdata", res);
    //   setIsLoading(false);

    //   if (res?.userData?.data?._id) {
    //     Swal.fire({
    //       position: "top-end",
    //       icon: "success",
    //       title: `${"Sign up success"}`,
    //       timer: 2000,
    //       showConfirmButton: true,
    //     });
    //     history.push("/sign-in");
    //   }
    // } catch (e) {
    //   // console.log(res);
    //   Swal.fire({
    //     position: "top-end",
    //     icon: "error",
    //     title: `${"Couldn't signup"}`,
    //     text: "Please try again with valid credentials",
    //     timer: 2000,
    //     showConfirmButton: true,
    //   });
    // }
  };

  return (
    <div className="sign_up">
      <div className="sign_up_doc">
        <div className="doctor_div">
          <div className="sign_up_doctor_img">
            <img alt="logo" src="/img/ladydoctor.jpg" />
          </div>
        </div>
      </div>
      <div className="backcolor">
        <div className="back_clr">
          <div className="sign_up_form">
            <div className="sign_up_logo">
              <Link to="/">
                <img alt="logo" src="/img/logo1.png"></img>
              </Link>

              <div className="sign_up_text">SIGN UP AS A PATIENT</div>
            </div>

            <form
              className="signup_form"
              onSubmit={(e) => {
                handleSubmit(e);
              }}
              onChange={(e) => {
                setData({ ...data, [e.target.name]: e.target.value });
              }}
            >
              <div className="sign_up_inputs">
                <div className="first-dev first">
                  <div
                    style={{
                      border: "1px solid #c7c7c7",
                      background: "#fff",
                      display: "flex",
                      width: "299px",
                      height: "48px",
                    }}
                  >
                    <img
                      alt="logo"
                      style={{
                        width: "22px",
                        height: "21px",
                        marginTop: "12px",
                        marginLeft: "12px",
                      }}
                      src="/img/account.svg"
                    ></img>
                    <input
                      style={{
                        border: "none",
                        marginLeft: "12px",
                        width: "80%",
                      }}
                      name="firstName"
                      placeholder="First Name"
                      required
                    />
                  </div>
                  <div
                    className="input-1 last"
                    style={{
                      border: "1px solid #c7c7c7",
                      display: "flex",
                      background: "#fff",
                      width: "299px",
                      height: "48px",
                    }}
                  >
                    <img
                      alt="logo"
                      style={{
                        width: "22px",
                        height: "21px",
                        marginTop: "12px",
                        marginLeft: "12px",
                      }}
                      src="/img/account.svg"
                    ></img>
                    <input
                      style={{
                        border: "none",
                        marginLeft: "12px",
                        width: "80%",
                      }}
                      name="lastName"
                      placeholder="Last Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className="first-dev second"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <div
                    className="input-1 third"
                    style={{
                      border: "1px solid #c7c7c7",
                      background: "#fff",
                      display: "flex",
                      width: "299px",
                      height: "48px",
                    }}
                  >
                    <img
                      alt="logo"
                      style={{
                        width: "22px",
                        height: "21px",
                        marginTop: "12px",
                        marginLeft: "12px",
                      }}
                      src="/img/mail.svg"
                    ></img>
                    <input
                      style={{
                        border: "none",
                        marginLeft: "12px",
                        width: "80%",
                      }}
                      name="email"
                      type={"email"}
                      placeholder="Email address"
                      required
                    />
                  </div>
                  <div
                    className="input-1 forth"
                    style={{
                      border: "1px solid #c7c7c7",
                      background: "#fff",

                      display: "flex",
                      width: "299px",
                      height: "48px",
                    }}
                  >
                    <img
                      alt="logo"
                      style={{
                        width: "22px",
                        height: "21px",
                        marginTop: "12px",
                        marginLeft: "12px",
                      }}
                      src="/img/phone.svg"
                    ></img>
                    <input
                      style={{
                        border: "none",
                        marginLeft: "12px",
                        width: "80%",
                      }}
                      type="number"
                      number="+1 234 567 8910"
                      name={"phoneNumber"}
                      placeholder="+1 234 567 8910"
                      required
                    />
                    {/* <AddPhoneNumber
                      enableEdit
                      callBack={(v) => {
                        setContactNo(v);

                        // queryClient.invalidateQueries("profile");
                      }}
                      value={contactNo}
                    /> */}
                  </div>
                </div>
                <div
                  className="first-dev fifth"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <div
                    className="input-1 sixth"
                    style={{
                      border: "1px solid #c7c7c7",
                      background: "#fff",

                      display: "flex",
                      width: "299px",
                      height: "48px",
                    }}
                  >
                    <img
                      alt="logo"
                      style={{
                        width: "22px",
                        height: "21px",
                        marginTop: "12px",
                        marginLeft: "12px",
                      }}
                      src="/img/smart-key.svg"
                    ></img>
                    <input
                      style={{
                        border: "none",
                        marginLeft: "12px",
                        width: "80%",
                      }}
                      name="password"
                      placeholder="Password"
                      type={"password"}
                      required
                    />
                  </div>
                  <div
                    className="input-1 seventh"
                    style={{
                      border: "1px solid #c7c7c7",
                      background: "#fff",

                      display: "flex",
                      width: "299px",
                      height: "48px",
                    }}
                  >
                    <img
                      alt="logo"
                      style={{
                        width: "22px",
                        height: "21px",
                        marginTop: "12px",
                        marginLeft: "12px",
                      }}
                      src="/img/smart-key.svg"
                    ></img>
                    <input
                      style={{
                        border: "none",
                        marginLeft: "12px",
                        width: "80%",
                      }}
                      name="confirmPassword"
                      type={"password"}
                      required
                      placeholder="Confirm Password"
                    />
                  </div>
                </div>
              </div>
              <button
                className="sign_menu"
                style={{ width: "138px", marginInline: "auto" }}
              >
                <button
                  className="themebutton_end"
                  disabled={isLoading ? true : false}
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    width: "135px",
                    paddingRight: " 45px",
                  }}
                >
                  SIGN UP
                </button>
                <div className="img_wrap_end" style={{ height: "40px" }}>
                  <img alt="logo" src="/img/chevron-right.svg" />
                </div>
              </button>
              <div className="sign_up_p">
                By proceeding, I agree that "SecondLookOrtho" or its
                representatives may contact me by email, phone, or SMS
                (including by automated means) at the email address or number I
                provide. I have read and understood the Terms &amp; Conditions.
              </div>
              <div className="centr-text-signup">
                Already have an account?
                <Link to="/sign-in">
                  <span>SIGN IN</span>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
